import React from 'react';
import { makeStyles } from '@mui/styles';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import Button from '@mui/material/Button';
import BimestreProfileInfo from './BimestreProfileInfo';

const useStyles = makeStyles({
    card: {
        margin: 'auto',
        width: '100%',
    },
    title: {
        fontSize: 25,
    },
    pos: {
        marginBottom: 12,
    },
});

export default function BimestreProfile({ bimestre, setBimestre }) {
    const classes = useStyles();

    const handleTrocaBimestre = () => {
        setBimestre(null)
    }

    return (
        <Card className={classes.card} variant="outlined">
            <CardContent>
                <BimestreProfileInfo bimestre={bimestre} />
                <CardActions>
                    <Button
                        onClick={handleTrocaBimestre}
                        size="small"
                        color="secondary"
                        variant="contained"
                    >Trocar Bimestre</Button>
                </CardActions>

            </CardContent>
        </Card>
    );
}